import apiClient from '../client';
import type { StaffProfile, CreateStaffProfilePayload, UpdateStaffProfilePayload } from '@/types';

const BASE = '/admin/staff';

export const staffProfilesApi = {
  list: (params?: Record<string, unknown>) =>
    apiClient.get<{ data: StaffProfile[]; pagination: { total: number } }>(BASE, { params }).then((r) => r.data),

  getById: (id: number) =>
    apiClient.get<{ data: StaffProfile }>(`${BASE}/${id}`).then((r) => r.data.data),

  create: (payload: CreateStaffProfilePayload) =>
    apiClient.post<{ data: StaffProfile }>(BASE, payload).then((r) => r.data.data),

  update: (id: number, payload: UpdateStaffProfilePayload) =>
    apiClient.put<{ data: StaffProfile }>(`${BASE}/${id}`, payload).then((r) => r.data.data),

  remove: (id: number) =>
    apiClient.delete(`${BASE}/${id}`),
};

